var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYourAffiliation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9004 5.56076C15.1494 6.01701 14.9814 6.58877 14.5252 6.83781L11.3308 8.58148C7.06072 10.9123 5.48865 16.2635 7.8195 20.5335C10.1504 24.8036 15.5015 26.3757 19.7716 24.0449L22.966 22.3012C23.4222 22.0522 23.994 22.2201 24.243 22.6764L24.6541 23.4296C24.9032 23.8858 24.7352 24.4576 24.279 24.7066L21.0846 26.4503C15.486 29.5063 8.47008 27.4451 5.41407 21.8466C2.35806 16.248 4.41922 9.23206 10.0178 6.17605L13.2122 4.43238C13.6684 4.18334 14.2402 4.35131 14.4892 4.80756L14.9004 5.56076Z",
    fill: "#1B0076"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1811 18.8318C29.8502 14.5617 24.4991 12.9896 20.229 15.3205L17.0346 17.0641C16.5784 17.3132 16.0066 17.1452 15.7576 16.689L15.3464 15.9358C15.0974 15.4795 15.2654 14.9078 15.7216 14.6587L18.916 12.915C24.5146 9.85904 31.5305 11.9202 34.5865 17.5188C37.6425 23.1174 35.5814 30.1333 29.9828 33.1893L26.7884 34.933C26.3322 35.182 25.7604 35.014 25.5114 34.5578L25.1002 33.8046C24.8512 33.3483 25.0192 32.7766 25.4754 32.5275L28.6698 30.7839C32.9399 28.453 34.5119 23.1019 32.1811 18.8318Z",
    fill: "#1B0076"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourAffiliation);
export default __webpack_public_path__ + "static/media/your-affiliation.2a08494e3db8d5562cec56b3f3a34dd4.svg";
export { ForwardRef as ReactComponent };